import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { BodyText, DisplayText, theme, useResponsive } from '@sg/garnish';

import { GiftCardBalance } from '../GiftCardBalance';
import { GiftCardRedemption } from '../GiftCardRedemption';

export const GiftCardInfo = (props: GiftCardInfoProps) => {
  const {
    giftCardCode,
    giftCardRegistrationCode,
    giftCardBalance,
    isFetchingGiftCardBalance,
    onRedeemGiftCardPress,
  } = props;

  const { currentBreakpoint } = useResponsive();
  const { formatMessage } = useIntl();

  if (currentBreakpoint.isXS) {
    return (
      <View style={styles.container}>
        <BodyText style={styles.titleXS} sizeMatch={['16']}>
          {formatMessage(messages.title)}
        </BodyText>

        <GiftCardBalance giftCardBalance={giftCardBalance} isLoading={isFetchingGiftCardBalance} />

        <GiftCardRedemption onNavigateToForm={onRedeemGiftCardPress} />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <DisplayText sizeMatch={['32']}>{formatMessage(messages.title)}</DisplayText>

      <GiftCardBalance giftCardBalance={giftCardBalance} isLoading={isFetchingGiftCardBalance} />

      <GiftCardRedemption
        giftCardCode={giftCardCode}
        giftCardRegistrationCode={giftCardRegistrationCode}
        onNavigateToForm={onRedeemGiftCardPress}
      />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing['4'],
  },
  titleXS: {
    paddingBottom: theme.spacing['2'],
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.GRAY,
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Your gift card',
    description: 'Gift Card Info | Title',
  },
  entry: {
    defaultMessage: 'Sweetgreen gift card',
    description: 'Gift Card Info | Entry',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardInfoProps = {
  giftCardCode?: string;
  giftCardRegistrationCode?: string;
  giftCardBalance: number;
  isFetchingGiftCardBalance: boolean;
  onRedeemGiftCardPress: () => void;
};
